export const formatDataType = (formattingData, dataNeededFormat) => {
	if(typeof dataNeededFormat === 'number') {
		return +formattingData
	}
	if(typeof dataNeededFormat === 'string') {
		return `${formattingData}`
	}
	return formattingData
}

export const getTableHeight = props => {
	const { height, cssHeight, data } = props
	let calcHeight = height
	if(!cssHeight && !calcHeight && data.length > 10) {
		calcHeight = 400
	}
	if(!cssHeight && (!calcHeight || calcHeight < 120) && data.length === 0) {
		calcHeight = 120
	}
	return calcHeight
}

export const numberColumn = (options = {}) => {
	const { toFixed = 2, locales, alignCellLeft, alignHeaderLeft } = options
	return {
		...!alignCellLeft && { style: { justifyContent: 'flex-end', borderRight: 'none' } },
		...!alignHeaderLeft && { headerStyle: { justifyContent: 'flex-end', borderRight: 'none' } },
		Cell: ({ value }) => {
			if(!value) {
				return null
			}
			return typeof value === 'number' ? value.toLocaleString(locales, {
				minimumFractionDigits: toFixed,
				maximumFractionDigits: toFixed
			}) : value
		}
	}
}
